import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import { DashboardCard, Statistic, Tag } from '@monorepo/nova-ui';
import { useDashboard } from '../../../../../contexts';

export const WeeklyProfitCard: FC = () => {
  const { accountBalance } = useDashboard();

  const { t } = useTranslation('keyMetrics');

  const weeklyPnL = accountBalance?.weeklyProfitAndLoss || 0;
  const currentBalance = accountBalance?.balance || 0;
  const isPositive = weeklyPnL >= 0;

  const calculateWeeklyPercentage = () => {
    if (weeklyPnL === 0) return '0.00%';

    const weekStartBalance = currentBalance - weeklyPnL;

    if (!weekStartBalance || weekStartBalance === 0) {
      return '0.00%';
    }

    const percentage = (weeklyPnL / weekStartBalance) * 100;
    return `${percentage.toFixed(2)}%`;
  };

  const percentageChange = calculateWeeklyPercentage();

  return (
    <DashboardCard
      sx={{
        justifyContent: 'space-between',
        minHeight: 100,
      }}
    >
      <Typography
        variant="body2"
        sx={(theme) => ({
          color: theme.palette.text.second,
          fontSize: theme.typography.pxToRem(14),
        })}
      >
        {t('cards.weeklyProfit.title')}
      </Typography>
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        gap={1}
        sx={{
          width: '100%',
        }}
      >
        <Typography
          component="div"
          sx={(theme) => ({
            fontSize: theme.typography.pxToRem(24),
          })}
        >
          <Statistic
            value={Math.abs(weeklyPnL).toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
            prefix={isPositive ? '$' : '-$'}
          />
        </Typography>
        <Tag
          label={percentageChange}
          color={isPositive ? 'success' : 'error'}
          size="small"
        />
      </Stack>
    </DashboardCard>
  );
};
